import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Dialog, Form, Input, MessagePlugin, Select } from 'tdesign-react';
import { createUser, updateUser } from '@/services/userService';
import { toTsOptions } from '@/utils/common';

const { FormItem } = Form;

export default function FormModal({ visible, handleClose, detail, options }) {
  const isEdit = !isEmpty(detail);
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);
        if (isEdit) {
          await updateUser({
            ...fields,
            id: detail.id,
          });
        } else {
          await createUser(fields);
        }
        MessagePlugin.success('操作成功');
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  useEffect(() => {
    if (visible && isEdit) {
      form.setFieldsValue(detail);
    } else {
      form.reset();
    }
  }, [form, visible, isEdit, detail]);

  return (
    <Dialog
      header={isEdit ? '修改用户' : '新建用户'}
      visible={visible}
      onClose={() => handleClose()}
      confirmBtn={{ loading: submitting, content: '确定' }}
      onConfirm={() => form.submit()}
      width={550}
    >
      <Form style={{ width: '90%' }} form={form} onSubmit={handleSubmit}>
        <FormItem name='username' label='用户名称' rules={[{ required: true }]}>
          <Input />
        </FormItem>
        <FormItem name='account' label='用户账号' rules={[{ required: true }]}>
          <Input />
        </FormItem>
        {!isEdit && (
          <FormItem name='password' label='用户密码' rules={[{ required: true }]}>
            <Input />
          </FormItem>
        )}
        <FormItem name='roleIds' label='用户角色' rules={[{ required: true }]}>
          <Select multiple options={toTsOptions(options)} />
        </FormItem>
      </Form>
    </Dialog>
  );
}
